<template>
<div class="custom d-inline">
    <bee-label class="custom d-inline"
		:color="localColor"
		:bold="true" :content="content" :empty-state="emptyState"
    >
    </bee-label>
</div>
</template>
<script>
export default {
name: "BeeQuantityLabel",
props: ["value", "emptyState", "color"],
computed: {
    localColor() {
        if(this.color)
            return this.color;
        if(this.value)
            return this.value.amount_status == 1 ? 'red' : 'black';
        return 'black'
    },
    content(){
        return this.value ? this.value.quantity : this.emptyState
    }
},
};
</script>
<style>
.custom {
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>
